import { AutoLength } from "./AutoLength";
import { StarLength } from "./StarLength";

export class LengthDefault {

    static Star: StarLength = new StarLength(1);
    
    static Auto: AutoLength = new AutoLength();
}